export default "__VITE_ASSET__BoZjl9Xt__"